import { TFailedResult, TResult } from './Result'

export function extractFailedResults<T> (
  list: Array<TResult<T>>,
): Array<TFailedResult<string | Error>> {
  const fails = list.filter((item) => item.status === 'fail')
  return fails
}
